<template>
    <div>
        <form @submit.prevent="saveSettings">
            <div class="form-group">
                <label>
                    <input type="checkbox" v-model="form.is_active" :value="1" :unchecked-value="0">
                    Aktifkan Fitur Ulang Tahun
                </label>
            </div>
            <div class="form-group">
                <label>Waktu Pengiriman:</label>
                <select v-model="form.send_time" class="form-control">
                    <option value="08:00">08:00</option>
                    <option value="12:00">12:00</option>
                    <option value="18:00">18:00</option>
                    <option value="custom">Custom</option>
                </select>
                <input v-if="form.send_time === 'custom'" type="time" v-model="customTime" class="form-control mt-2" />
            </div>
            <div class="form-group">
                <label>Device Pengiriman:</label>
                <multiselect 
                    v-model="form.device_ids" 
                    tag-placeholder="Pilih Device Pengirim"
                    placeholder="Pilih Device Pengirim" 
                    label="name" 
                    :custom-label="customLabel" 
                    track-by="id"
                    :options="devices" 
                    :multiple="true"
                    :loading="isLoadingDevices"
                >
                </multiselect>
                <small class="form-text text-muted">
                    Pilih satu atau lebih device untuk mengirim pesan ulang tahun
                </small>
            </div>
            <div class="form-group">
                <label>Template Default:</label>
                <select v-model.number="form.default_template_id" class="form-control">
                    <option :value="null">Pilih Template</option>
                    <option v-for="template in templates" :key="template.id" :value="template.id">{{ template.title }}</option>
                </select>
            </div>
            <div class="form-group">
                <label>
                    <input type="checkbox" v-model="form.random_template" :value="1" :unchecked-value="0">
                    Random Template
                </label>
            </div>
            <button type="submit" class="btn btn-primary">Simpan Pengaturan</button>
        </form>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    components: {
        Multiselect
    },
    data() {
        return {
            form: {
                is_active: 0,
                send_time: "08:00",
                device_ids: [],
                default_template_id: null,
                random_template: 0
            },
            customTime: "08:00",
            templates: [],
            devices: [],
            isLoadingDevices: false
        };
    },
    methods: {
        async loadSettings() {
            try {
                let response = await this.$store.dispatch("birthday/birthday_settings_get");
                if (response.data.data.setting) {
                    const setting = response.data.data.setting;
                    // Convert boolean to integer for form
                    // Map device_ids after devices are loaded
                    let deviceIds = [];
                    if (setting.device_ids && Array.isArray(setting.device_ids)) {
                        deviceIds = setting.device_ids.map(id => {
                            const device = this.devices.find(d => d.id === id);
                            return device || { id: id, name: `Device ${id}` };
                        });
                    }
                    
                    this.form = {
                        is_active: setting.is_active === true || setting.is_active === 1 ? 1 : 0,
                        send_time: setting.send_time || "08:00",
                        device_ids: deviceIds,
                        default_template_id: setting.default_template_id ? parseInt(setting.default_template_id) : null,
                        random_template: setting.random_template === true || setting.random_template === 1 ? 1 : 0
                    };
                    
                    // Set custom time if send_time is not in predefined options
                    if (this.form.send_time && !["08:00", "12:00", "18:00"].includes(this.form.send_time)) {
                        this.customTime = this.form.send_time;
                        this.form.send_time = "custom";
                    }
                }
            } catch (err) {
                // Ignore
            }
        },
        async loadDevices() {
            this.isLoadingDevices = true;
            try {
                let response = await this.$store.dispatch('device_list_all');
                this.devices = response.data.data.devices.map(device => ({
                    id: device.id,
                    name: device.name,
                    status: device.status
                }));
            } catch (err) {
                this.$toast.error("Gagal memuat device");
            } finally {
                this.isLoadingDevices = false;
            }
        },
        customLabel({ name, status }) {
            return `${name} (${status})`;
        },
        async loadTemplates() {
            try {
                let response = await this.$store.dispatch("birthday/birthday_template_list", { limit: 100, page: 1 });
                this.templates = response.data.data.templates || [];
            } catch (err) {
                // Ignore
            }
        },
        async saveSettings() {
            try {
                // Prepare data for backend (ensure all integers are correct)
                // Helper function to convert to integer
                const toInt = (val) => {
                    if (val === true || val === 1 || val === "1") return 1;
                    if (val === false || val === 0 || val === "0" || val === null || val === undefined) return 0;
                    return parseInt(val) || 0;
                };
                
                // Convert device_ids to array of IDs
                const deviceIds = this.form.device_ids && Array.isArray(this.form.device_ids)
                    ? this.form.device_ids.map(device => device.id || device)
                    : [];
                
                if (deviceIds.length === 0) {
                    this.$toast.error("Pilih minimal satu device");
                    return;
                }

                const dataToSend = {
                    is_active: toInt(this.form.is_active),
                    send_time: this.form.send_time === 'custom' ? this.customTime : (this.form.send_time || "08:00"),
                    device_ids: deviceIds,
                    default_template_id: this.form.default_template_id && this.form.default_template_id !== "" && this.form.default_template_id !== 0 
                        ? parseInt(this.form.default_template_id) 
                        : null,
                    random_template: toInt(this.form.random_template)
                };

                // Ensure send_time is string (not null)
                if (!dataToSend.send_time) {
                    dataToSend.send_time = "08:00";
                }

                await this.$store.dispatch("birthday/birthday_settings_update", dataToSend);
                this.$toast.success("Pengaturan berhasil disimpan");
            } catch (err) {
                this.$toast.error(err.response?.data?.message || "Gagal menyimpan pengaturan");
            }
        }
    },
    async mounted() {
        await this.loadDevices();
        await this.loadSettings();
        await this.loadTemplates();
    }
};
</script>

